import React from "react";
import { InfoShell, InfoSection } from "@/components/InfoShell";
import { Seo, organizationJsonLd } from "@/components/Seo";

export default function About() {
  return (
    <InfoShell testid="about-page" eyebrow="About" title="About PropertyConnect">
      <Seo
        title="About PropertyConnect | The Intelligent Real Estate Network"
        description="PropertyConnect is a professional real-estate network and marketplace connecting properties, buyer demand and professionals through smarter matching and collaboration."
        canonical="/about"
        robots="index,follow"
        jsonLd={organizationJsonLd()}
      />
      <InfoSection heading="What PropertyConnect Is">
        <p><strong>PropertyConnect</strong> is The Intelligent Real Estate Network for the Philippines — a
        professional real-estate network and marketplace that connects properties, active buyer demand and real-estate
        professionals through smarter matching and collaboration. Connect. Match. Collaborate. Close.</p>
        <p className="mt-3 text-sm text-slate-500">PropertyConnect is operated by KODA Technologies Inc.</p>
      </InfoSection>
      <InfoSection heading="Our Purpose">
        <p>Real-estate opportunities are often fragmented across different professionals and organisations.
        PropertyConnect brings them together so a listing on one side can meet a Buyer Need on the other —
        helping professionals match faster, collaborate and close more deals.</p>
      </InfoSection>
      <InfoSection heading="How PropertyConnect Works">
        <p>Professionals publish properties and post Buyer Needs. A deterministic matching engine
        surfaces relevant matches between them. Professionals can then send inquiries, request collaboration
        and work opportunities together.</p>
      </InfoSection>
      <InfoSection heading="Who It Is For">
        <p>Licensed brokers, real-estate salespersons, property managers, owner representatives and developer
        representatives across the Philippines — whether independent, brokerage-affiliated or developer-affiliated.</p>
      </InfoSection>
      <InfoSection heading="Professional Collaboration">
        <p>PropertyConnect is built around co-operation. Matched professionals can connect and collaborate on
        opportunities while contact and client details stay protected until both sides choose to engage.</p>
      </InfoSection>
      <InfoSection heading="Independent &amp; Developer-Neutral">
        <p>PropertyConnect is an independent, cross-company network. Matching is based on property and buyer
        attributes — not on any single developer, brokerage or organisation.</p>
      </InfoSection>
    </InfoShell>
  );
}
